const state = () => {
  return {
    works: [],
    work: {},
  }
}

export default state;
